import { calculateGridTemplateColumns } from 'components/DesignSystems/FilterHeader/calculateGridTemplateColumns';
import FilterCardHeader from 'components/DesignSystems/FilterHeader/FilterCardHeader';
import FormCheckboxField from 'components/IAP/formFields/FormCheckboxField';
import FormNumericField from 'components/IAP/formFields/FormNumericField';
import FormTextField from 'components/IAP/formFields/FormTextField';
import { PlannedResourceRow } from 'components/IAP/hooks/assignmentListHooks';
import AssignmentCardResourceAttachmentDialog from './AssignmentCardResourceAttachmentDialog';
import { useState } from 'react';

const AssignmentCardPlannedResourceEdit = ({
  plannedResource,
}: {
  plannedResource: PlannedResourceRow;
}) => {
  const gridTemplateColumns = calculateGridTemplateColumns(5);

  const id = plannedResource.id;

  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <FilterCardHeader gridTemplateColumns={gridTemplateColumns}>
        <div>{''}</div>
        <div className="px-3">
          <FormTextField
            title=""
            fieldName={`resource.${id}.resourceName`}
            disabled
          />
        </div>
        <div className="px-3">
          <FormTextField title="" fieldName={`resource.${id}.leader`} />
        </div>
        <div className="px-3">
          <FormNumericField
            fieldName={`resource.${id}.numberOfPersons`}
            title=""
            min={0}
            step={1}
            rules={{
              min: { value: 0, message: 'Cannot be negative' },
              pattern: {
                value: /^\d+$/,
                message: 'Must be a whole number',
              },
            }}
          />
        </div>
        <div className="px-3">
          <FormTextField title="" fieldName={`resource.${id}.contactInfo`} />
        </div>
        <div className="px-3">
          <FormTextField title="" fieldName={`resource.${id}.reportingInfo`} />
        </div>
        <div className="d-flex flex-column align-items-center">
          <FormCheckboxField
            title="204a"
            fieldName={`resource.${id}.has204a`}
          />
        </div>
      </FilterCardHeader>
      {showDialog && (
        <AssignmentCardResourceAttachmentDialog
          onClose={() => setShowDialog(false)}
          data={plannedResource}
        />
      )}
    </>
  );
};

export default AssignmentCardPlannedResourceEdit;
